import React from "react";
import "./loadingStyle.css";

const Loader = ({ layoutLoader }) => {
  return <div className={`loading ${layoutLoader ? "loading-shift" : ""}`}>Loading&#8230;</div>;
};

export const LoaderABS = (props) => {
  return <div className="loading-absolute">Loading&#8230;</div>;
};

export default Loader;
